import React from "react";
import { Item, useListState } from "react-stately";
import {
  mergeProps,
  useFocusRing,
  useListBox,
  useOption,
  useListBoxSection,
  useSeparator,
} from "react-aria";
import clsx from "clsx";

interface ListBoxProps {}

export const ListBox = (props) => {
  let state = useListState(props);
  let ref = React.useRef();
  let { listBoxProps, labelProps } = useListBox(props, state, ref);

  return (
    <React.Fragment>
      <div {...labelProps}>{props.label}</div>
      <div {...listBoxProps} ref={ref} className="divide-y">
        {Array.from(state.collection).map((item) =>
          item.type === "section" ? (
            <ListBoxSection key={item.key} section={item} state={state} />
          ) : (
            <ListOption key={item.key} item={item} state={state} />
          )
        )}
      </div>
    </React.Fragment>
  );
};

export const ListOption = ({ item, state }) => {
  // Get props for the option element
  let ref = React.useRef();
  let { optionProps, isSelected, isDisabled } = useOption(
    { key: item.key },
    state,
    ref
  );

  // Determine whether we should show a keyboard
  // focus ring for accessibility
  let { isFocusVisible, focusProps } = useFocusRing();

  return (
    <div
      {...mergeProps(optionProps, focusProps)}
      ref={ref}
      className={clsx(
        "px-3 py-1 cursor-pointer text-sm text-gray-900 flex",
        isSelected && "bg-sky-300",
        isFocusVisible ? "" : "outline-none"
      )}
      // style={{
      //   background: isSelected ? "blueviolet" : "transparent",
      //   color: isDisabled ? "#aaa" : isSelected ? "white" : null,
      //   padding: "2px 5px",
      //   outline: isFocusVisible ? "2px solid orange" : "none",
      // }}
    >
      {item.rendered}
    </div>
  );
};

export const ListBoxSection = ({ section, state }) => {
  let { itemProps, headingProps, groupProps } = useListBoxSection({
    heading: section.rendered,
    "aria-label": section["aria-label"],
  });

  let { separatorProps } = useSeparator({
    elementType: "li",
  });

  // If the section is not the first, add a separator element.
  // The heading is rendered inside an <li> element, which contains
  // a <ul> with the child items.
  return (
    <>
      {section.key !== state.collection.getFirstKey() && (
        <li
          {...separatorProps}
          style={{
            borderTop: "1px solid gray",
            margin: "2px 5px",
          }}
        />
      )}
      <li {...itemProps}>
        {section.rendered && (
          <span
            {...headingProps}
            style={{
              fontWeight: "bold",
              fontSize: "1.1em",
              padding: "2px 5px",
            }}
          >
            {section.rendered}
          </span>
        )}
        <ul
          {...groupProps}
          style={{
            padding: 0,
            listStyle: "none",
          }}
        >
          {[...section.childNodes].map((node) => (
            <ListOption key={node.key} item={node} state={state} />
          ))}
        </ul>
      </li>
    </>
  );
};
